import type { FC } from 'react'

import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Get expert guidance`,
  description: `Successful CDP implementation requires thoughtfulness and guidance at each stage of the data journey. Segment Professional Services helps organizations stay thoughtful and strategic while realizing tangible outcomes like data democratization, higher LTV, improved retention, stronger loyalty, and greater ROI. Our expertise breaks silos and unlocks your full potential with recommendations and best practices—from architectures and planning to technical integrations and enablement.`,
}

const ExpertGuidance: FC = () => {
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <StyledCopyTextBase centered={true}>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </StyledCopyTextBase>
      </Section.Copy>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 0;
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-top: 40px;
    }
  }
`

const StyledCopyTextBase = styled(CopyTextBase)`
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    text-align: left;
  }
`

export default ExpertGuidance
